import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const WarrantiesExclusionsChanges = ({ data }) => {
  const value = data?.warrantiesExclusions?.newValue?.trim();

  // Do not render if empty or null
  if (!value) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid #d9d9d9',
        mb: 2,
        overflow: 'hidden',
        borderRadius: 0,
      }}
    >
      {/* Blue Header */}
      <Box
        sx={{
          backgroundColor: '#5569ff',
          color: '#fff',
          px: '8px',
          py: '4px',
         
        }}
      >
        Warranties /exclusions
      </Box>

      {/* Content */}
      <Box sx={{ px: 2, py: 2 }}>
        <Typography>{value}</Typography>
      </Box>
    </Paper>
  );
};

export default WarrantiesExclusionsChanges;